import { DecimalPipe, formatCurrency } from '@angular/common';
import { Component, Input, OnChanges, OnInit, Output, EventEmitter, ViewEncapsulation, Inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { SimuladorService } from '../simulador.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../_services/api.service';
import { Cliente } from '../entity-models/cliente.model';
import { Simulacion } from '../entity-models/simulacion.model';
import { ConfiguracionInicialDTO } from '../entity-models/configuracionInicialDTO.model';
import { DetalleLinea } from '../entity-models/detalle-linea.model';
import { ObjetoFinanciable } from '../entity-models/objeto-financiable.model';
import { CategoriaEmpresa } from '../entity-models/categoria-empresa.model';
import { CategoriaAgricola } from '../entity-models/categoria-agricola.model';
import { SectorEconomico } from '../entity-models/sector-economico.model';
import { Periodicidad } from '../entity-models/periodicidad.model';
import { Cuota } from '../entity-models/cuota.model';
import { SimulacionDTO } from '../entity-models/simulacionDTO.model';
import { MatStepper } from '@angular/material/stepper';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Excedido } from '../home/home.component';
import { saveAs } from 'file-saver/src/FileSaver';
import { ActivatedRoute } from '@angular/router';
import { sinIva } from '../_helpers/utils';
import { CAT_MEDIANA_TRAMO_1, ID_CATEGORIA_MAXIMA, LINEAS_CAPITAL_TRABAJO } from '../constantes';




@Component({
    selector: 'app-simulador',
    templateUrl: './simulador.component.html',
    styleUrls: ['./simulador.component.less'],
    animations: [
        trigger('fade', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate(2000, style({ opacity: 1 }))
            ])
        ])
    ],
    providers: [DecimalPipe, MatSnackBar],
    encapsulation: ViewEncapsulation.None,
})



export class SimuladorComponent implements OnInit, OnChanges {

    cantidadSimuladores: number;
    selectGracia: any;
    mostrarGracia = true;
    selectCuotas: any;
    mostrarCuotas = true;
    cuotasMin: number;
    datosParaSimulacion = {
        smvm: 0,
        TNA: 0,
        tipo: 0, // tipo de inversión a financiar (destino)
        tasaDescuento: 0,
        tasaNominal: 0,
        tasaPeriodica: 0
    };
    subscription: Subscription;
    dataSource: DatosFinanciacion[];
    displayedColumns: string[] = ['nro', 'periodo', 'saldo', 'capital', 'interes', 'cuota'];
    datos: DatosFinanciacion;
    smvm: number = 20578.50;
    tasaNacion: number = 40.85;
    tasaDescuento: number = 50;
    tasaNominal: number = 20.43; // Tasa Nominal Anual
    tasaPeriodica: number;
    indice: number;
    montoMin: number = 0;
    montoMed: number;
    montoMax: number;
    montoMaxConfiguracion: number;
    excedeMonto: boolean = false;
    cuotas: number; // Periodos
    gracia: number; //  Periodo de Gracia
    periodicidad: number; // Periocidad de Pago (valor)
    periodicidadNombre: string; // Periocidad de Pago (nombre)
    cuota: number;
    total: number = 0;
    totalInput: number = 0;
    cuotasDefault: number;
    graciaDefault: number;
    actividadOriginal: number = null;
    sectorEconomicoOriginal: number = null;
    categoriaOriginal: CategoriaEmpresa = null;
    caracteristicasFinanciacion: DetalleLinea[];
    periodisidadDisponible: any;
    mostrarMonto: boolean = true;
    mostrarTasa: boolean = false;
    mostrarSelects: boolean = false;
    mostrarDetalle: boolean = false;
    mostrarTabla: boolean = false;
    topeTasaInteres?: number = null;
    tieneTopeTasaInteres: boolean = false;
    modoConsulta: boolean = false;
    sinIva: boolean = false;
    modalExcedidoMostrado: boolean = false;
    ocultarMensajeSuperarMontoMaximo: boolean = false;

    bubbleMonto = '';
    bubbleTasa = '';

    @Input() pymeNueva: boolean;
    @Input() sectorEconomico: SectorEconomico;
    @Input() sectorAgricola: boolean;
    @Input() categoriaAgricola: CategoriaAgricola;
    @Input() actividad: number;
    @Input() categoria: CategoriaEmpresa;
    @Input() hectareas: number;
    @Input() destinoSeleccionado: ObjetoFinanciable;
    @Input() configuracion: ConfiguracionInicialDTO;
    @Input() cliente: Cliente;
    @Input() stepper: MatStepper;
    @Output() limpiarDestinoSeleccionadoEmit = new EventEmitter();

    cantidadCuotasFinal = 0;
    cantidadeMesesGraciaFinal = 0;
    isMobile = false;
    detalleLinea: DetalleLinea;
    categoriaCalculada: number;
    categoriaCalculadaDetalleLinea: DetalleLinea;
    periodicidadSelected = new Periodicidad();
    fechaTasa = new Date(); // actualizar con fecha de tasa del backend
    simulacionGenerada: Simulacion;
    showToast = false;
    messageToast = 'Email enviado correctamente!';
    classToast = 'bg-success text-light';

    constructor(
        private simuladorService: SimuladorService,
        private apiService: ApiService,
        private decimalPipe: DecimalPipe,
        private snackBar: MatSnackBar,
        public dialog: MatDialog,
        private route: ActivatedRoute,
    ) {

        this.subscription = this.simuladorService.getSimuladores().subscribe(cantidad => {
            if (cantidad) {
                this.cantidadSimuladores = cantidad;
            } else {
                //  clear messages when empty message received
            }
        });
    }

    ngOnInit(): void {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            this.isMobile = true;
        }

        this.route.fragment.subscribe((fragment: string) => {
            if (fragment && fragment === 'consulta') {
                this.modoConsulta = true;
            }
        });

        const scrollToTop = window.setInterval(() => {
            const pos = window.pageYOffset;
            if (pos > 0) {
                window.scrollTo(0, pos - 20); // how far to scroll on each step
            } else {
                window.clearInterval(scrollToTop);
            }
        }, 16);
    }

    async ngOnChanges() {

        this.caracteristicasFinanciacion = this.configuracion.detallesLineas
            .filter((d) => d.linea.id === this.destinoSeleccionado.linea.id);

        this.detalleLinea = this.configuracion.detallesLineas
            .filter((d) => d.categoriaEmpresa.id === this.categoria.id && d.linea.id === this.destinoSeleccionado.linea.id)[0];

        this.topeTasaInteres = this.detalleLinea.topeTasaInteres; // Valor inicial, que puede cambiar al cambiar el monto

        this.tieneTopeTasaInteres = this.topeTasaInteres !== null && typeof this.topeTasaInteres == 'number';

        this.categoriaOriginal = this.categoria;

        this.smvm = this.configuracion.constantes.salarioMinimoVitalMovil;

        this.tasaNacion = this.configuracion.constantes.tasaNominalAnualBNA;

        this.montoMaxConfiguracion = this.getMontoMaximo(this.detalleLinea);


        const esCategoriaMaxima = this.detalleLinea.categoriaEmpresa.id == ID_CATEGORIA_MAXIMA;
        const esMedianaTramo1 = this.detalleLinea.categoriaEmpresa.id == CAT_MEDIANA_TRAMO_1;
        const esCapitalTrabajo = LINEAS_CAPITAL_TRABAJO.includes(this.detalleLinea.linea.id);

        this.ocultarMensajeSuperarMontoMaximo = esCategoriaMaxima || (esMedianaTramo1 && esCapitalTrabajo);

        // Logs!
        console.log('Es Pyme Nueva: ' + this.pymeNueva);
        console.log('Sector Economico: ' + this.sectorEconomico.nombre);
        console.log('Sector Agricola: ' + this.sectorAgricola);
        console.log('Actividad: ' + this.actividad);
        console.log('Categoria Empresa ' + this.categoria.nombre);
        console.log('Destino: ' + this.destinoSeleccionado.nombre);
        console.log("Detalles de linea - Filtro por linea"); console.log(this.caracteristicasFinanciacion);
        console.log("Detalles de linea -  Filtro por Categoria"); console.log(this.detalleLinea);
        if (this.tieneTopeTasaInteres) {
            console.log('LINEA CON TOPE DE TASA: ' + this.topeTasaInteres)
        }

        this.reiniciar();
        this.updateMonto();
        this.updateMontoToTotal(0);
    }

    getMontoMaximo(detalleLinea: DetalleLinea) {
        const idLinea = detalleLinea.linea.id;
        const esCapitalTrabajo = LINEAS_CAPITAL_TRABAJO.includes(idLinea);

        // Si es capital de trabajo, el monto maximo debe ser el de
        // cat mediana tramo 1 (id 5)

        if (esCapitalTrabajo) {

            // Filtro los detalles de linea para buscar la que tenga CAT_MEDIANA_TRAMO_1
            // Y el id de linea provisto
            const detalleLineaRequerida = this.configuracion.detallesLineas
                .filter(detalleLinea =>
                    detalleLinea.categoriaEmpresa.id == CAT_MEDIANA_TRAMO_1
                    && detalleLinea.linea.id == idLinea
                );

            if (detalleLineaRequerida.length == 0) {
                console.error("No se pudo encontrar una linea con las caracteristicas definidas al obtener monto maximo de simulacion. Se setea valor maximo por default.");
                return this.configuracion.constantes.montoMaximoSimulacion;
            }

            return detalleLineaRequerida[0].topeSMVM * this.configuracion.constantes.salarioMinimoVitalMovil;
        }

        return this.configuracion.constantes.montoMaximoSimulacion;
    }

    reiniciar() {
        const allRanges = document.querySelectorAll('.range-wrap');
        allRanges.forEach(wrap => {
            const range = wrap.querySelector('.range');
            const bubble = wrap.querySelector('.bubble-container');
            range.addEventListener('input', () => {
                this.setBubble(range, bubble);
            });
            this.setBubble(range, bubble);
        });
        this.selectGracia = [];
        this.selectCuotas = [];
        this.gracia = null;
        this.cuotas = null;
    }

    setBubble(range, bubble) {
        setTimeout(() => {
            range.value = this.total == null ? 0 : this.total;
            const val = range.value ? range.value : 0;
            const min = range.min ? range.min : 0;
            const max = range.max ? range.max : 100;
            const newVal = Number(((val - min) * 100) / (max - min));
            const monto = formatCurrency(val, 'es-AR', '$', 'ARS', '1.0-0');
            const tasa = this.transformDecimal(this.tasaNominal) + '%';
            // Actualiza valor de tope de tasa despues del calculo.
            this.topeTasaInteres = this.categoriaCalculadaDetalleLinea.topeTasaInteres;
            this.tieneTopeTasaInteres = this.topeTasaInteres !== null && typeof this.topeTasaInteres == 'number';
            const categoriaCalculada = this.categoriaCalculadaDetalleLinea.categoriaEmpresa.nombre;
            bubble.innerHTML = `
                    <div class="bubble red">
                        ${categoriaCalculada || this.categoriaOriginal.nombre } <br>
                        ${'TNA: ' + (tasa) }
                    </div>
                    <br>
                    <div class="bubble">
                        ${monto}
                    </div>`.trim();

            //  Sorta magic numbers based on size of the native UI thumb
            bubble.style.left = `calc(${newVal}% + (${12 - newVal * 0.15}px))`;
            const value = (range.value - range.min) / (range.max - range.min) * 100;
            range.style.background = `linear-gradient(to right, #575757 0%, #c52126 ${value}%, #ffffff ${value}%, white 100%)`;
        }, 1

        );
    }

    calcularCategoria() {
        const detalleLinea: DetalleLinea = this.categoriaCalculadaDetalleLinea;
        console.log('TOPE SMVM: ' + detalleLinea.topeSMVM);
        this.montoMax = this.pymeNueva
          ? this.configuracion.constantes.montoMaximoSimulacion
          : this.detalleLinea.topeSMVM * this.smvm;
        this.montoMed = this.montoMax / 2;
        this.cuotas = this.cuotasDefault = detalleLinea.mesesPlazoDevolucion;
        this.gracia = this.graciaDefault = detalleLinea.mesesGracia;
        this.tasaNominal = (this.tasaNacion * detalleLinea.porcentajeTasaNominalAnualBNA) / 100;
        this.sinIva = sinIva(detalleLinea.linea.id);
    }

    setCategoria(monto: number) {
        let cat: number;
        let index = this.caracteristicasFinanciacion.findIndex(value => value.categoriaEmpresa.id === this.categoriaOriginal.id);
        if (this.categoriaOriginal.id === 4) {
            index = this.caracteristicasFinanciacion.findIndex(value => value.categoriaEmpresa.id === 3);
        }
        for (let i = index; i < this.caracteristicasFinanciacion.length; i++) {
            if (this.categoriaOriginal.id === this.caracteristicasFinanciacion[i].categoriaEmpresa.id && monto <= this.caracteristicasFinanciacion[i].topeSMVM * this.smvm) {
                cat = i;
                break;
            } else {
                cat = i + 1;
                if ((this.caracteristicasFinanciacion[i].topeSMVM * this.smvm) > monto) {
                    cat = i;
                    break;
                }
                if (cat <= this.caracteristicasFinanciacion.length - 1
                    && (this.caracteristicasFinanciacion[i].topeSMVM * this.smvm) < monto
                    && (this.caracteristicasFinanciacion[cat].topeSMVM * this.smvm) > monto) {
                    break;
                }
                if (i === this.caracteristicasFinanciacion.length - 1) {
                    cat = i;
                }
            }
        }
        this.categoriaCalculada = cat;
        this.categoriaCalculadaDetalleLinea = this.caracteristicasFinanciacion[this.categoriaCalculada];
    }

    updateMonto(tooltip?) {
        console.log('CategoriaOriginal: ' + this.categoriaOriginal.nombre);
        if (this.total > this.montoMaxConfiguracion && tooltip) {
            setTimeout(() => {
                tooltip.open();
            }, 1);
        } else if (tooltip) {
            setTimeout(() => {
                if (tooltip.isOpen()) {
                    tooltip.close();
                }
            }, 1);
        }
        this.setCategoria(this.total);
        this.calcularCategoria();

        const montoTope = this.detalleLinea.topeSMVM * this.smvm;
        this.excedeMonto = this.total > montoTope;

        // NO se muestra modal si es pyme nueva o si ya se mostro anteriormente
        if (!this.modalExcedidoMostrado && this.excedeMonto && !this.pymeNueva) {
            // Display modal info.
            this.mostrarModalexcedido(this.categoriaOriginal.nombre, montoTope);
            this.modalExcedidoMostrado = true;
            console.log('Excede monto, actualizo categoria: ' + this.categoriaCalculada);
        }

        setTimeout(() => {
            const range = document.querySelector('.range');
            const bubble = document.querySelector('.bubble-container');
            this.setBubble(range, bubble);
        }, 1);

        this.mostrarTasa = true;
        this.mostrarSelects = true;
        this.reiniciar();
    }

    updateMontoToTotal(total) {
        this.total = total;
        setTimeout(() => {
            const range = document.querySelector('.range');
            const bubble = document.querySelector('.bubble-container');
            this.setBubble(range, bubble);
        }, 1);
    }

    setCuotas(cuotas: number) {
        console.log('CUOTAS: ' + cuotas);
        this.cuotas = cuotas;
    }

    setGracia(periodos: number) {
        console.log('Gracia: ' + periodos);
        this.gracia = periodos;
        this.cuotas = null;
        this.selectCuotas = [];
        this.mostrarCuotas = false;
        setTimeout(() => {
            this.llenarSelectCuotas();
        }, 1);
    }

    setPeriodicidadDisponible(capitalDeTrabajo: boolean) {
        this.periodisidadDisponible = [
            { valor: 1.00, nombre: 'Mensual' },
            { valor: 3.00, nombre: 'Trimestral' },
            { valor: 6.00, nombre: 'Semestral' },
        ];
    }

    setPeriodicidad(tipo) {
        console.log('Periodicidad: ' + tipo);
        this.gracia = null;
        this.cuotas = null;
        this.selectGracia = [];
        this.selectCuotas = [];
        this.mostrarGracia = false;
        this.mostrarCuotas = false;
        setTimeout(() => {
            this.llenarSelectGracia(tipo);
        }, 1);
    }

    llenarSelectGracia(valor: Periodicidad) {
        this.selectGracia = [];
        let cantGracia;
        cantGracia = this.categoriaCalculadaDetalleLinea.mesesGracia / valor.cantidadMeses;
        for (let index = 0; index <= cantGracia; index++) {
            this.selectGracia.push(index * valor.cantidadMeses);
        }

        this.mostrarGracia = true;
        this.mostrarCuotas = true;

    }

    llenarSelectCuotas() {
        this.selectCuotas = [];
        let cuotasMin, cantCuotas;
        cuotasMin = this.categoriaCalculadaDetalleLinea.mesesPlazoDevolucion;
        cantCuotas = (this.categoriaCalculadaDetalleLinea.mesesPlazoDevolucion / this.periodicidadSelected.cantidadMeses) - (Number(this.gracia) / this.periodicidadSelected.cantidadMeses);
        let num = Number(this.gracia) + 1;
        const inicial = (Number(this.gracia) / this.periodicidadSelected.cantidadMeses);
        for (let index = 1; index <= cantCuotas + inicial; index++) {
            if (index <= cantCuotas) {
                num = index * Number(this.periodicidadSelected.cantidadMeses);
                this.selectCuotas.push(num);
            }
        }
        this.mostrarCuotas = true;
    }

    /**
     * Ver backend/app/Simulation.php:30
     */
    calcular() {
        const TOTAL = Number(this.total);
        const PLAZO_GRACIA = this.isMobile ? 'Gracia' : 'Plazo de gracia';
        const PLAZO_DEVOLUCION = this.isMobile ? 'Devolución' : 'Plazo de devolución';
        const PERIODICIDAD_MESES = Number(this.periodicidadSelected.cantidadMeses);
        const CANT_CUOTAS = Number(this.cuotas);
        const MESES_GRACIA = Number(this.gracia);
        const INTERES_CERO = this.detalleLinea.linea.interesCero;
        const periodos = CANT_CUOTAS / PERIODICIDAD_MESES + MESES_GRACIA / PERIODICIDAD_MESES;
        const cuotasGracia = MESES_GRACIA / PERIODICIDAD_MESES;


        this.cantidadCuotasFinal = CANT_CUOTAS;
        this.cantidadeMesesGraciaFinal = MESES_GRACIA;

        const tasa = this.topeTasaInteres > 0 ? this.topeTasaInteres : this.tasaNominal;
        const tasaPeriodica = tasa / (12 / PERIODICIDAD_MESES);

        this.dataSource = [];

        this.dataSource.push({
            nro: 0,
            periodo: 'Desembolso',
            desembolso: TOTAL, // Se desembolsa el total solicitado
            saldo: TOTAL,
            interes: 0,
            capital: 0,
            cuota: 0
        });

        let saldo = TOTAL;
        let capital = 0;
        let interesAcumulado = 0;
        let interes = 0;
        const montoCuota = TOTAL / (CANT_CUOTAS / PERIODICIDAD_MESES);

        for (let i = 1; i <= periodos; i++) {
            const enPlazoDeGracia = (i - 1) < cuotasGracia;
            const inicioPlazoDevolucion = (i - 1) == cuotasGracia;

            capital = enPlazoDeGracia ? 0 : montoCuota;
            saldo = enPlazoDeGracia ? TOTAL : saldo - capital;

            const interesCalculado = (saldo + capital) * (tasaPeriodica / 100);

            /**
             * Si la linea tiene INTERES_CERO, no se suman intereses
             * en periodo de gracia (pero se acumulan). Luego, en la
             * primera cuota del periodo de devolucion, se suman los
             * intereses acumulados.
             */
            if (INTERES_CERO) {
                interesAcumulado+= interesCalculado;
                if (inicioPlazoDevolucion) {
                    interes = interesAcumulado;
                } else {
                    interes = enPlazoDeGracia
                        ? 0
                        : interesCalculado;
                }
            } else {
                interes = interesCalculado;
            }

            const periodo = enPlazoDeGracia ? PLAZO_GRACIA : PLAZO_DEVOLUCION;
            const cuota = capital + interes;

            this.dataSource.push({
                nro: i,
                desembolso: 0, // No hay desembolsos parciales.
                periodo,
                capital,
                saldo,
                interes,
                cuota,
            });
        }

        this.mostrarMonto = false;
        this.mostrarDetalle = false;
        this.mostrarTabla = true;

        if (!this.modoConsulta) {
            this.saveSimulacion();
        }
    }

    volverPrimerPaso() {
        this.periodicidadSelected = null;
        this.mostrarMonto = true;
        this.mostrarDetalle = false;
        this.mostrarTabla = false;
        this.reiniciar();
        this.updateMonto();
    }

    primerPaso() {
        this.mostrarMonto = true;
        this.mostrarDetalle = true;
        this.mostrarTabla = false;
    }

    saveSimulacion() {
        const simulacion = new Simulacion();
        simulacion.objetoFinanciable = this.destinoSeleccionado.nombre;
        simulacion.sectorEconomico = this.sectorEconomico.nombre;
        simulacion.startUp = this.pymeNueva;
        if (this.sectorAgricola) {
            simulacion.categoriaAgricola = this.categoriaAgricola.nombre;
            simulacion.categoriaEmpresa = this.categoriaAgricola.categoriaEmpresa.nombre;
        } else {
            simulacion.categoriaEmpresa = this.categoriaOriginal.nombre;
        }
        simulacion.categoriaEmpresaCalculada = this.categoriaCalculadaDetalleLinea.categoriaEmpresa.nombre;
        simulacion.periodicidad = this.periodicidadSelected.nombre;
        simulacion.linea = this.categoriaCalculadaDetalleLinea.linea.nombre;
        simulacion.periodoGracia = this.gracia;
        simulacion.salarioMinimoVitalMovil = this.smvm;
        simulacion.tasaNominalAnualBNA = this.tasaNacion;
        simulacion.montoSolicitado = this.total;
        simulacion.sinIva = sinIva(this.detalleLinea.linea.id);
        simulacion.porcentajeInversion = this.categoriaCalculadaDetalleLinea.porcentajeInversion
        simulacion.tasaNominalAnualFTyC = this.tasaNominal;
        simulacion.topeTasa = this.topeTasaInteres;
        simulacion.cantCuotas = this.cuotas;
        simulacion.interesCero = this.detalleLinea.linea.interesCero || false;
        const simulacionDTO = new SimulacionDTO();
        simulacionDTO.simulacion = simulacion;
        simulacionDTO.cliente = this.cliente;
        simulacionDTO.cuotas = this.dataSource.map((v) => {
            const cuota = new Cuota();
            cuota.numero = v.nro;
            cuota.saldo = v.saldo;
            cuota.periodo = v.periodo;
            cuota.capital = v.capital;
            cuota.interes = v.interes;
            cuota.desembolso = v.desembolso;
            cuota.valorCuota = v.cuota;
            return cuota;
        });
        this.apiService.saveSimulacion(simulacionDTO).subscribe(
            res => {
                this.simulacionGenerada = res.body;
            }, error1 => {
                console.log('Error');
            }
        );
    }

    transformDecimal(num) {
        return this.decimalPipe.transform(num, '1.2-2');
    }

    checkPymeNueva(next: boolean, stepper: MatStepper) {
        if (next) {
            if (this.pymeNueva) {
                stepper.next();
                setTimeout(() => {
                    stepper.next();
                });
            } else {
                stepper.next();
            }
        } else {
            if (this.pymeNueva) {
                stepper.selectedIndex = 3;
            } else {
                stepper.previous();
            }
        }
    }

    simularOtroCredito(stepper: MatStepper) {
        setTimeout(() => {
            this.destinoSeleccionado.accepted = false;
            this.limpiarDestinoSeleccionadoEmit.emit();
            stepper.selectedIndex = this.modoConsulta ? 1 : 2;
        }, 1);
    }

    sendEmail() {
        this.apiService.sendEmail(this.simulacionGenerada.id).subscribe((res) => {
            if (res.body === 'correcto') {
                this.openSnackBar('Email enviado correctamente!');
            } else {
                this.openSnackBar('El email no pudo ser enviado!');
            }
        }, error1 => {
            this.openSnackBar('El email no pudo ser enviado!');
        });
    }

    openSnackBar(mensaje: string): void {
        const horizontalPositionS: MatSnackBarHorizontalPosition = 'center';
        const verticalPositionS: MatSnackBarVerticalPosition = 'bottom';
        this.snackBar.open(mensaje, '', {
            horizontalPosition: horizontalPositionS,
            verticalPosition: verticalPositionS,
            duration: 3000,
            panelClass: 'message-position'
        });
    }

    mostrarModalexcedido(
        categoria: any,
        monto: any,
    ) {
        const dialogRef = this.dialog.open(Excedido, {
            data: {categoria, monto }
        });
        dialogRef.afterClosed().subscribe(result => {});
    }



    imprimirSimulacion() {
        const result = this.apiService.printSimulacion(this.simulacionGenerada.id);
        const name = 'Simulacion FTYC.pdf';
        result.subscribe(
            (data) => {
                this.descargarArchivo(data.body, 'application/pdf', name);
            },
            (err) => {
            }
        );
    }


    descargarArchivo(_buffer: Uint8Array, _type: string, name: string) {
        const blob = new Blob([_buffer], { type: _type });

        // Use FileSaver.js to save the blob
        saveAs(blob, name);
    }

}

export class DatosSimulación {

}

export class DatosFinanciacion {
    nro: number;
    periodo: string;
    desembolso: number;
    saldo: number;
    capital: number;
    interes: number;
    cuota: number;
}

export class TipoDestino {
    tipo: number;
    nombre: string;
}
